import React, { forwardRef, InputHTMLAttributes } from 'react';
import BaseTextArea from './BaseTextArea';
import { IconKey } from './Icon';

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    iconKey?: IconKey;
    rows?: number;
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
    return <BaseTextArea ref={ref} {...props} />;
});

export default TextArea;
